module.exports = __webpack_public_path__ + "media/images/homepage/reason-1-dd350815cc81fc86937da85a626ed559.png";